module.exports = __webpack_public_path__ + "img/admin-2014-meeting.4ebe2410.jpg";